import { getAutomationsRouteContext } from '@/lib/automations/automationRoutes.js';
import normalizePathname from '@/lib/routes/normalizePathname.js';
import getPieveRouteMatch from '@/lib/routes/getPieveRouteMatch.js';
import getNormalizedThreadId from '@/redux/selectors/pieveSelectors/lib/getNormalizedThreadId.js';

const extractRouteThreadId = ({ pathname = '' } = {}) => {
  const normalizedPathname = normalizePathname(pathname);
  const routeMatch = getPieveRouteMatch(normalizedPathname);
  const normalizedThreadId = getNormalizedThreadId(routeMatch?.params?.threadId);

  if (normalizedThreadId) {
    return normalizedThreadId;
  }

  const automationsRouteContext = getAutomationsRouteContext(normalizedPathname);

  // The Automate host for a workflow thread carries the thread id itself.
  if (automationsRouteContext?.type === 'workflows' && automationsRouteContext?.isConversation) {
    return getNormalizedThreadId(automationsRouteContext.id);
  }

  if (!automationsRouteContext?.isEdit) {
    return null;
  }

  if (automationsRouteContext?.type === 'workflows') {
    return null;
  }

  return getNormalizedThreadId(routeMatch?.params?.automationId);
};

export default extractRouteThreadId;
